import { cleanObject } from '@/common/functions/cleanObject';
import Api from '../api';
const { axios: api } = Api;
const PREFIX = 'person';

import queryString from 'query-string';

export const regeneratePersonImage = async (payload) => {
	const data = await api.post(`/${PREFIX}/regenerate-image`, payload);
	return { data: data.data };
};

export const getPersonsForCustomer = async (payload) => {
	const data = await api.get(
		`/${PREFIX}/find-for-customer?${queryString.stringify(
			cleanObject(payload),
			{
				arrayFormat: 'bracket',
			},
		)}`,
	);
	return { data: data.data };
};

export const getPersonsGuestPreview = async (payload) => {
	const data = await api.get(
		`/${PREFIX}/guest-preview?${queryString.stringify(
			cleanObject(payload),
			{
				arrayFormat: 'bracket',
			},
		)}`,
	);
	return { data: data.data };
};

export const getPersonGuestPreview = async (personId, payload) => {
	const data = await api.get(
		`/${PREFIX}/guest-preview/${personId}?${queryString.stringify(
			cleanObject(payload),
			{
				arrayFormat: 'bracket',
			},
		)}`,
	);
	return { data: data.data };
};

export const getPersonsGuestStoriesPreview = async (payload) => {
	const data = await api.get(
		`/${PREFIX}/guest-stories-preview?${queryString.stringify(
			cleanObject(payload),
			{
				arrayFormat: 'bracket',
			},
		)}`,
	);
	return { data: data.data };
};

export const getPersonTags = async (payload) => {
	const data = await api.get(
		`/${PREFIX}/tags?${queryString.stringify(cleanObject(payload), {
			arrayFormat: 'bracket',
		})}`,
	);
	return { data: data.data };
};

export const getPerson = async (personId, { language } = {}) => {
	const params = language ? { language } : {};
	const data = await api.get(`/${PREFIX}/${personId}`, { params });
	return { data: data.data };
};
